import { t } from "@lingui/macro";

import PageTitle from "components/PageTitle/PageTitle";

export function DashboardPageTitle({ tradePageVersion }: { tradePageVersion: number }) {
  return (
    <PageTitle
      title={t`Tokens`}
      subtitle={
        tradePageVersion === 1 ? (
          <>
            MONEY is the utility and governance token. Accrues 25% of markets generated fees.
            <br />
            MLP is the liquidity provider token for MONEY markets. Accrues 65% of the markets generated fees.
          </>
        ) : (
          <>
            MONEY is the utility and governance token. Accrues 30% and 27% of V1 and V2 markets generated fees, respectively.
            <br />
            GM is the liquidity provider token for MONEY V2 markets. Accrues 63% of the V2 markets generated fees.
          </>
        )
      }
    />
  );
}
